import {Directive, Input} from '@angular/core';
import {NG_VALIDATORS, UntypedFormControl, Validator} from '@angular/forms';

@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnUrl][formControlName], [cmnUrl][formControl], [cmnUrl][ngModel]',
    providers: [{provide: NG_VALIDATORS, useExisting: CmnUrlDirective, multi: true}]
})
export class CmnUrlDirective implements Validator {
    @Input() matching: string;  // A regex pattern to match

    validate(c: UntypedFormControl): { [key: string]: any } {
        return c.value && (!this.isUrl(c.value) || !this.matches(c.value)) ? {invalid: true} : null;
    }

    isValidUrl(input?: string): boolean {
        if (!input) {
            return false;
        }
        try {
            const url = new URL(input);
            return url.protocol === 'http:' || url.protocol === 'https:';
        } catch {
            return false;
        }
    }

    isUrl(input?: string): boolean {
        return this.isValidUrl(input);
    }

    matches(input?: string): boolean {
        if(this.matching) {
            const regex = new RegExp(this.matching, 'i');
            return input ? (regex.test(input)) : false;
        }

        return true;
    }
}
